import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useAuth0 } from '@auth0/auth0-vue'

export async function authGuard(
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0()

  const waitForAuth = () =>
    new Promise<void>((resolve) => {
      const check = () => {
        if (!isLoading.value) {
          resolve()
          return
        }
        setTimeout(check, 100)
      }
      check()
    })

  await waitForAuth()

  if (isAuthenticated.value) {
    next()
  } else {
    await loginWithRedirect({
      appState: { target: _to.fullPath },
    })
  }
}
